
import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import { useLanguage } from '@/contexts/LanguageContext';
import { motion } from 'framer-motion';

interface BlogPostContentProps {
  htmlContent: string;
  languageCode: string;
}

const BlogPostContent: React.FC<BlogPostContentProps> = ({ htmlContent, languageCode }) => {
  // Using dangerouslySetInnerHTML, but the content is controlled by us
  // and properly sanitized before being stored in the database
  return (
    <motion.div 
      className="prose prose-invert max-w-none mt-6 text-gray-200" 
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      transition={{ delay: 0.4, duration: 0.8 }}
    >
      <div 
        className="blog-content text-lg"
        dangerouslySetInnerHTML={{ __html: htmlContent }} 
      />
    </motion.div>
  );
};

export default BlogPostContent;
